import {
    Store,
    Fuel,
    KeyRound,
    Wrench,
    PaintBucket,
    CircleDot,
    Hammer,
    Bus,
    Truck,
} from "lucide-react";
import { Reveal } from "./Reveal";

const CLIENTS = [
    { icon: Store, label: "Concessionarie e vendita auto", sub: "con assistenza qualificata" },
    { icon: Fuel, label: "Stazioni di rifornimento", sub: "e autolavaggi" },
    { icon: KeyRound, label: "Aziende di noleggio", sub: "flotte auto e furgoni" },
    { icon: Wrench, label: "Officine meccaniche", sub: "e centri revisione" },
    { icon: PaintBucket, label: "Carrozzerie", sub: "sollevamento e aspirazione" },
    { icon: CircleDot, label: "Gommisti", sub: "smontagomme, equilibratrici, assetto" },
    { icon: Hammer, label: "Artigiani automotive", sub: "elettrauto, moto, veicoli speciali" },
    { icon: Bus, label: "Trasporto pubblico e privato", sub: "depositi e lavaggio bus" },
    { icon: Truck, label: "Officine camion", sub: "sollevamento e gomme mezzi pesanti" },
];

export const Clienti = () => (
    <section
        id="clienti"
        data-testid="clienti-section"
        className="border-y border-slate-200 bg-[#F2F5F9] py-16 lg:py-20"
    >
        <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
            <div className="grid gap-10 lg:grid-cols-12 lg:items-start">
                <div className="lg:col-span-4">
                    <Reveal>
                        <span className="text-xs font-bold uppercase tracking-[0.22em] text-[#E30613]">
                            A chi ci rivolgiamo
                        </span>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">
                            Il partner tecnico di chi lavora sui veicoli.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <p className="mt-5 text-sm leading-relaxed text-[#475569] sm:text-base">
                            Dalla concessionaria all'officina camion, ogni cliente ha esigenze
                            diverse: le ascoltiamo, progettiamo la soluzione e la seguiamo nel tempo
                            con assistenza diretta in tutto il Sud Italia.
                        </p>
                    </Reveal>
                </div>
                <div className="grid gap-3 sm:grid-cols-2 lg:col-span-8 lg:grid-cols-3">
                    {CLIENTS.map((c, i) => (
                        <Reveal key={c.label} delay={0.05 + i * 0.04}>
                            <div
                                data-testid={`client-type-${i}`}
                                className="group flex h-full items-start gap-3.5 rounded-2xl border border-slate-200 bg-white p-4 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#0B1F3A]/25 hover:shadow-[0_16px_40px_-16px_rgba(11,31,58,0.2)]"
                            >
                                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#0B1F3A]/[0.06] transition-colors duration-300 group-hover:bg-[#E30613]/10">
                                    <c.icon
                                        className="h-5 w-5 text-[#0B1F3A] transition-colors duration-300 group-hover:text-[#E30613]"
                                        strokeWidth={1.8}
                                    />
                                </span>
                                <span>
                                    <span className="block text-sm font-bold text-[#0B1F3A]">
                                        {c.label}
                                    </span>
                                    <span className="mt-0.5 block text-xs text-[#4F5D70]">
                                        {c.sub}
                                    </span>
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);
